// extracted by mini-css-extract-plugin
export default {"button":"APButtonPrimary_button__lOov1","buttonFitContent":"APButtonPrimary_buttonFitContent__XBPKe"};